import { Inject, Injectable } from "@angular/core";
import { createEffect } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { CoreState, CustomerManagementSelector, JurisdictionSelector } from "@obg/ngx.core";
import { RouteSelector } from "@obg/ngx.router";
import { DataBusFacade } from "remote-module-context";
import { combineLatest } from "rxjs";
import { delay, distinctUntilChanged, filter, map, tap } from "rxjs/operators";

import { T_SHELL_DATA_BUS_FACADE } from "../injection";

@Injectable({
	providedIn: "root",
})
export class CustomerEffects {
	customerCountryCode$ = createEffect(
		() =>
			this.store.select(CustomerManagementSelector.getCustomer).pipe(
				map((customer) => customer?.address.country),
				distinctUntilChanged(),
				tap((countryCode) => this.dataBus.dispatch({ key: "customerCountryCode", value: countryCode }))
			),
		{ dispatch: false }
	);

	jurisdictionHorseRacingNotification$ = createEffect(
		() =>
			combineLatest([
				this.store.select(JurisdictionSelector.get),
				this.store.select(RouteSelector.getCurrent),
			]).pipe(
				filter(([_, currentRoute]) => !!currentRoute?.name.includes("horse-racing")),
				delay(3000),
				tap(([jurisdiction, _]) => {
					this.dataBus.dispatch({
						key: "jurisdiction",
						value: jurisdiction,
					});
				})
			),
		{ dispatch: false }
	);

	constructor(
		@Inject(T_SHELL_DATA_BUS_FACADE) public dataBus: DataBusFacade,
		private store: Store<CoreState>
	) {}
}
